import { TileLayer, BitmapLayer, GeoJsonLayer } from 'deck.gl';

const VIDEO_URL = "./video/aflica.mp4"

const video =  function(){
  const videoEl = document.createElement("video");
  videoEl.crossOrigin = "anonymous"; 
  videoEl.preload = "auto"; 
  videoEl.muted = true; 
  videoEl.loop = true; 

  const source = document.createElement("source");
  source.src = VIDEO_URL; 
  videoEl.append(source); 

  videoEl.addEventListener('canplaythrough', (event) => {
    videoEl.play();
  });

  return videoEl;
}

export function renderLayers({data}) {
  const v = video();

  const videolayer = new BitmapLayer({
    id: "bitmap-layer",
    opacity:0.5,
    bounds: [-18.698368046353494, -36.16300755581617, 52.229366328646506, 38.1446395611524],
    image: v
  });

  //OSMタイルを読み込みベースマップとして表示
  const tileLayer = new TileLayer({
    id:"tile-layer",
    data: "https://c.tile.openstreetmap.org/{z}/{x}/{y}.png",
    minZoom: 0,
    maxZoom: 19,
    tileSize: 256,

    renderSubLayers: (props) => {
      const {
        bbox: { west, south, east, north }
      } = props.tile;

      return new BitmapLayer(props, {
        data: null,
        image: props.data,
        bounds: [west, south, east, north]
      });
    }
  });  

  //レイヤーの重なり順を配列で指定(先頭のレイヤーが一番下になる)
  return [tileLayer, videolayer];
}
